import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Disaster_Impact from '../../../Assets/Images/Training/Training Compendium/Disaster_Impact.jpg';

const Disaster_Impact_Resilience_of_Critical_Infrastructure = () => {

    return (
        <div className="mt-5">
            <h4>Disaster Impact & Resilience of Critical Infrastructure</h4>

            <div className="card mt-5">
                <img
                    src={Disaster_Impact}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p><strong>Aim:</strong> The aim of the compendium is to serve as a central, authoritative resource  and knowledge repository that equips participants and professionals with the  strategic frameworks, technical methodologies, and innovative solutions needed to  enhance the resilience of critical infrastructure against disasters.</p>
                <p>This compendium, ‘Disaster Impact & Resilience of Critical Infrastructure’ serves  as collateral repository, outlining comprehensive exploration of the vulnerabilities  and consequences that disasters pose to critical infrastructure systems. It  emphasizes the socio-economic, environmental, technical, and operational  implications of disruptions caused by natural and human-induced hazards. The  program addresses the interdependencies and cascading effects that failures in  infrastructure such as power supply, water, healthcare, transport, and  communication can trigger during disaster events. Participants will engage with  strategic frameworks and methodologies to enhance infrastructure resilience,  focusing on risk assessment, redundancy planning, adaptive design, and recovery  mechanisms. The program also highlights innovative solutions and emerging  technologies for strengthening critical systems, ensuring continuity, and fostering  long-term urban resilience against future shocks and stresses.</p>
            </div>

        </div>
    );
};

export default Disaster_Impact_Resilience_of_Critical_Infrastructure;
